import { SignalTestRowState } from "../types";

import RequestLogsContent from "./RequestLogsContent";

import AnalyticsEmptyState from "@/components/RequestsAnalytics/AnalyticsEmptyState";
import { SignalSampleRequestLog } from "@/queries/signals";

interface DrawerContentProps {
  isLoading: boolean;
  requestLogs: SignalSampleRequestLog[];
  workspaceId: number;
  testStates: Record<number, SignalTestRowState>;
  isTestingAll: boolean;
  hasAssertion: boolean;
  onRemoveRequest: (requestLogId: number) => void;
  onTestRequest: (requestLogId: number) => void;
}

const DrawerContent = ({
  isLoading,
  requestLogs,
  workspaceId,
  testStates,
  isTestingAll,
  hasAssertion,
  onRemoveRequest,
  onTestRequest,
}: DrawerContentProps) => {
  if (requestLogs.length === 0 && !isLoading) {
    return (
      <div className="flex min-h-0 flex-1 items-center justify-center px-6 py-8">
        <AnalyticsEmptyState
          title="No requests selected"
          description="Use Add Requests above to choose request logs for testing."
        />
      </div>
    );
  }

  return (
    <div className="min-h-0 flex-1 overflow-y-auto">
      <RequestLogsContent
        isLoading={isLoading}
        requestLogs={requestLogs}
        workspaceId={workspaceId}
        testStates={testStates}
        isTestingAll={isTestingAll}
        hasAssertion={hasAssertion}
        onRemoveRequest={onRemoveRequest}
        onTestRequest={onTestRequest}
      />
    </div>
  );
};

export default DrawerContent;
